// extracted by mini-css-extract-plugin
export default {"loginPayBox":"loginPay_loginPayBox__IETt4"};